import CompanyProfileSettings from "../company-profile-settings";

export default function TabProfileSettings(props) {
    return <CompanyProfileSettings {...props} tabIndex={3} tabPrefix="pharmacy" nameLabel="PharmacyName"/>;
}
